import script from "./WageLedgerConvertModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./WageLedgerConvertModal.vue?vue&type=script&setup=true&lang=ts"

import "./WageLedgerConvertModal.vue?vue&type=style&index=0&id=5b741eb6&lang=scss"

const __exports__ = script;

export default __exports__